import { useEffect, useState } from "react";

import _ from "lodash";
import { ToastContainer } from "react-toastify";

import {
	Avatar,
	Box,
	Button,
	FormControl,
	FormLabel,
	Grid,
	Stack,
	Switch,
	TextField,
	Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useNavigate, useParams } from "react-router-dom";
import { getCurationDetails, UpdateCuration } from "../../apis/Curation";
import { ImageCropper } from "../../components/CommonFunctions/ImageCropper";
import Grouplist from "../../components/Curation/Grouplist";
import FormWrapper from "../../components/Form/FormWrapper";

// const useStyles = makeStyles()((theme) => ({
// 	title: {
// 		flexGrow: 1,
// 		display: "none",
// 		[theme.breakpoints.up("sm")]: {
// 			display: "block",
// 		},
// 	},
// }));

export const EditCuration = () => {
	const navigate = useNavigate();
	const [curation, setCuration] = useState(null);
	const [, setLoading] = useState(false);

	const [groupList, setGroupList] = useState([]);
	const { id } = useParams();

	// new states for edit page
	const {
		register,
		handleSubmit,

		control,
		reset,

		watch,
		formState: { errors },
	} = useForm({
		defaultValues: {
			title: "",
		},
	});

	const [curationImage, setCurationImage] = useState(null);
	const [filename, setFilename] = useState("");
	const [crop, setCrop] = useState(false);

	useEffect(() => {
		console.log(curation);

		if (curation) {
			reset({
				title: curation.title || "",
				creation_date_time:
					curation.creation_date_time !== null
						? curation.creation_date_time
						: curation.created_at,
				active: curation.active,
				owner_id: curation.owner.id || "",
				playoff: curation.playoff.id || "",
			});
			setCurationImage(curation.image?.file);
			// setGroupList(curation.groups);
			const tempProdArr = [];
			curation.products.map((item) => tempProdArr.push(item.id));

			// setProducts(tempProdArr);
			const updatedGroups = curation.groups.map((group) => ({
				...group,
				products: curation.products.filter(
					({ id }) =>
						group.products.includes(id) && tempProdArr.includes(id)
				),
			}));

			setGroupList(updatedGroups);
		}
	}, [curation, reset]);

	useEffect(() => {
		setLoading(true);
		_.debounce(async () => {
			const curationDetails = await getCurationDetails(id);
			setCuration(curationDetails);
		}, 500)();
		setLoading(false);
	}, [id]);

	const handleOnChange = (event) => {
		const newImage = event.target?.files?.[0];
		console.log(newImage);
		if (newImage) {
			// console.log(newImage);
			setFilename(newImage.name);
			setCurationImage(URL.createObjectURL(newImage));
			setCrop(true);
		}
	};

	const onSubmit = async (data) => {
		// if (!products.length) {
		// 	notify("Please Add products");
		// 	return;
		// }
		// data["grouped_list"] = isGrouped;

		// data["creation_date_time"] = startDate.format();

		const formData = new FormData();
		for (const i in data) {
			if (i === "file") {
				console.log(i);
				console.log(i, data[i]);
				if (data[i].length) {
					const blob = await fetch(curationImage).then((r) => r.blob());
					formData.append("file", blob, filename);
				}
			} else {formData.append(i, data[i]);}
		}
		// data["products"] = products.map((g) => parseInt(g));
		// formData.append("products", data["products"]);
		// formData.append("tag_in_insta", insta);
		console.log(data);

		formData.append("pin_to_top", curation.pin_to_top);
		const res = await UpdateCuration(formData, id);
		if (res.success) {
			navigate("/w86zjruk6q/curation");
		}
	};

	return (
		<Grid container justifyContent="center" spacing={2}>
			<ToastContainer />
			<Grid item xs={12} md={8} xl={6}>
				<Box sx={{ px: 5 }}>
					<FormWrapper onSubmit={handleSubmit(onSubmit)}>
						<Box display="flex" justifyContent="space-between">
							<Typography variant="h6" gutterBottom>
								Edit Curation
							</Typography>
						</Box>

						<Box my={3}>
							<TextField
								{...register("title", {
									required: "Enter Curation title",
								})}
								key={watch("title") ?? "empty"}
								fullWidth
								// name="title"
								label="Title"
								variant="outlined"
								error={Boolean(errors.title)}
								helperText={errors.title?.message}
							/>
						</Box>

						<Box my={3}>
							<Grid
								container
								spacing={2}
								justifyContent={"center"}
							>
								<Grid item container spacing={2} md={6} xs={6}>
									<Grid item xs={12}>
										<TextField
											fullWidth
											name="Owner"
											label="Owner"
											variant="outlined"
											InputProps={{
												readOnly: true,
											}}
											value={
												curation
													? curation?.owner.name
													: ""
											}
										/>
									</Grid>
									<Grid item xs={12}>
										<TextField
											fullWidth
											name="playoff"
											label="Playoff"
											variant="outlined"
											InputProps={{
												readOnly: true,
											}}
											value={
												curation?.playoff.title || ""
											}
										/>
									</Grid>
									<Grid item xs={12}>
										<LocalizationProvider
											dateAdapter={AdapterDayjs}
										>
											<Controller
												control={control}
												name="creation_date_time"
												defaultValue={null}
												rules={{
													required:
														"please select the creation date and time",
													validate: {
														// min: (date) => {
														//   return (
														//     date.isAfter(dayjs()) ||
														//     "Please, enter a future date"
														//   );
														// },
													},
												}}
												render={({
													field: {
														ref,
														onBlur,
														onChange,
														name,
														...field
													},
													fieldState,
												}) => (
													<DateTimePicker
														{...field}
														onChange={(
															newValue
														) => {
															onChange(newValue);
														}}
														inputRef={ref}
														label="Creation date & time"
														renderInput={(
															inputProps
														) => (
															<TextField
																fullWidth
																{...inputProps}
																onBlur={onBlur}
																name={name}
																error={
																	!!fieldState.error
																}
																helperText={
																	fieldState
																		.error
																		?.message
																}
															/>
														)}
													/>
												)}
											/>
										</LocalizationProvider>
									</Grid>
									<Grid item xs={12}>
										<Box
											sx={{
												paddingX: 2,
												paddingY: 0.75,
												border: "1px solid rgba(0, 0, 0, 0.23)",
												borderRadius: "4px",
											}}
										>
											<Stack
												direction={"row"}
												justifyContent="space-between"
												alignItems={"center"}
											>
												<FormLabel>Active</FormLabel>
												<Controller
													name="active"
													control={control}
													defaultValue={false}
													render={({ field }) => (
														<Switch
															{...field}
															checked={
																field.value
															}
															onChange={(e) =>
																field.onChange(
																	e.target
																		.checked
																)
															}
														// disabled
														// sx={{ pointerEvents: "none" }}
														/>
													)}
												/>
											</Stack>
										</Box>
									</Grid>
								</Grid>
								<Grid
									item
									container
									spacing={2}
									md={6}
									xs={6}
									justifyContent={"center"}
									alignItems={"center"}
								>
									<Grid item xs={12}>
										{/* {curationImage && ( */}
										<>
											<Box
												sx={{
													textAlign: "center",
												}}
											>
												<FormControl
													error={Boolean(errors.file)}
												>
													{curationImage && (
														<Avatar
															variant="square"
															src={curationImage}
															sx={{
																width: 150,
																height: 150,
																objectFit:
																	"fill",
																marginBottom: 2,
																marginX: "auto",
															}}
														/>
													)}
													<Button
														variant="contained"
														component="label"
														onChange={
															handleOnChange
														}
													>
														{!curationImage
															? "Upload "
															: "Change "}
														image
														<input
															hidden
															accept="image/*"
															id="file-upload"
															type="file"
															{...register(
																"file",
																{
																	// required: image == null,
																}
															)}
															error={errors.file}
														/>
													</Button>
												</FormControl>
											</Box>
											<ImageCropper
												image={curationImage}
												setImage={setCurationImage}
												open={crop}
												setOpen={setCrop}
												aspect={1}
											/>
										</>
										{/* )} */}
									</Grid>
								</Grid>
							</Grid>
						</Box>

						<Box my={3}>
							<Grouplist groupList={groupList} />
						</Box>

						<Box mb={3}>
							<Button
								type="submit"
								fullWidth
								// onClick={handleSave}
								color="primary"
								variant="contained"
							>
								{"Save"}
							</Button>
						</Box>
					</FormWrapper>
				</Box>
			</Grid>
		</Grid>
	);
};
